import { RotatividadeGridController } from './rotatividade.grid.controller';

export class RotatividadeGridComponent {
    static selector = 'rotatividadeGridComponent';
    static controller = RotatividadeGridController;
    static template = require('!!html-loader!./rotatividade.grid.html');
    static bindings = {
        secao: '<',
        aba: '@',
        agrupamento: '<',
        exibirtotais: '<',
        carregando: '<',
        ordenacao: '<',
        onOrdenar: '&',
    };
}
